import WifiOffIcon from "@mui/icons-material/WifiOff"
import { Box, Grid, Typography } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import { useTranslation } from "react-i18next"

const OfflineBanner = () => {
    const theme = useTheme()
    const { t } = useTranslation()

    return (
        <Grid
            container
            flexDirection="row"
            justifyContent="center"
            alignItems="center"
            px={0.5}
            sx={{
                backgroundColor: theme.palette.warning.dark,
                py: { xs: 1, sm: 0.5 },
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: theme.zIndex.snackbar,
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <WifiOffIcon sx={{ fontSize: 18 }} />
                <Typography variant="body2" my={0.5}>
                    {t("editor:offlineBanner")}
                </Typography>
            </Box>
        </Grid>
    )
}

export default OfflineBanner
